import { WeatherSnowyHeavyIcon } from './WeatherSnowyHeavyIcon';

/**
 * author: Michael Irigoyen
 * id D97DA5D6-5A65-4ADB-B124-48C22F32B07A
 * name weather-snowy-heavy
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-snowy-heavy.svg
 * tags
 * - Weather 
 */
export const FlurriesIcon = WeatherSnowyHeavyIcon;
export default FlurriesIcon